import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  font-size: 18px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import debounce from "lodash/debounce";
import React, { useCallback, useEffect, useRef } from "react";
import { useMatchBreakpoints } from "../../contexts";
import { Box } from "../Box";
import { DropdownMenuItemType } from "../DropdownMenu/types";
import MenuItem from "../MenuItem/MenuItem";
import { ChevronLeftIcon, ChevronRightIcon, OpenNewIcon } from "../Svg";
import StyledSubMenuItems, { LeftMaskLayer, RightMaskLayer, StyledSubMenuItemWrapper, SubMenuItemWrapper } from "./styles";
import styled from "styled-components";
var Text = styled.div.withConfig({
    componentId: "sc-20cf9e41-0"
})(_templateObject());
var SUBMENU_CHEVRON_CLICK_MOVE_PX = 100;
var SUBMENU_SCROLL_DEVIATION = 3;
var SubMenuItems = function(_param) {
    var _items = _param.items, items = _items === void 0 ? [] : _items, activeItem = _param.activeItem, _isMobileOnly = _param.isMobileOnly, isMobileOnly = _isMobileOnly === void 0 ? false : _isMobileOnly, props = _object_without_properties(_param, [
        "items",
        "activeItem",
        "isMobileOnly"
    ]);
    var isMobile = useMatchBreakpoints().isMobile;
    var scrollLayerRef = useRef(null);
    var chevronLeftRef = useRef(null);
    var chevronRightRef = useRef(null);
    var layerController = useCallback(function() {
        if (!scrollLayerRef.current || !chevronLeftRef.current || !chevronRightRef.current) return;
        var scrollLayer = scrollLayerRef.current;
        if (scrollLayer.scrollLeft === 0) chevronLeftRef.current.classList.add("hide");
        else chevronLeftRef.current.classList.remove("hide");
        if (scrollLayer.scrollLeft + scrollLayer.offsetWidth < scrollLayer.scrollWidth - SUBMENU_SCROLL_DEVIATION) chevronRightRef.current.classList.remove("hide");
        else chevronRightRef.current.classList.add("hide");
    }, []);
    useEffect(function() {
        layerController();
    }, [
        layerController
    ]);
    return /*#__PURE__*/ _jsxs(SubMenuItemWrapper, _object_spread_props(_object_spread({
        $isMobileOnly: isMobileOnly
    }, props), {
        children: [
            isMobile && items.length > 3 && /*#__PURE__*/ _jsx(LeftMaskLayer, {
                ref: chevronLeftRef,
                onClick: function() {
                    if (!scrollLayerRef.current) return;
                    scrollLayerRef.current.scrollLeft -= SUBMENU_CHEVRON_CLICK_MOVE_PX;
                },
                children: /*#__PURE__*/ _jsx(ChevronLeftIcon, {})
            }),
            isMobile && items.length > 3 && /*#__PURE__*/ _jsx(RightMaskLayer, {
                ref: chevronRightRef,
                onClick: function() {
                    if (!scrollLayerRef.current) return;
                    scrollLayerRef.current.scrollLeft += SUBMENU_CHEVRON_CLICK_MOVE_PX;
                },
                children: /*#__PURE__*/ _jsx(ChevronRightIcon, {})
            }),
            /*#__PURE__*/ _jsx(StyledSubMenuItems, {
                justifyContent: "center",
                pl: [
                    "12px",
                    null,
                    "0px"
                ],
                onScroll: debounce(layerController, 100),
                ref: scrollLayerRef,
                children: items.map(function(param) {
                    var label = param.label, labelItem = param.labelItem, href = param.href, icon = param.icon, itemProps = param.itemProps, type = param.type, disabled = param.disabled;
                    var Icon = icon;
                    var isExternalLink = type === DropdownMenuItemType.EXTERNAL_LINK;
                    var linkProps = isExternalLink ? {
                        as: "a",
                        target: "_blank"
                    } : {};
                    var isActive = href === activeItem;
                    return label && /*#__PURE__*/ _jsx(StyledSubMenuItemWrapper, {
                        mr: "20px",
                        children: /*#__PURE__*/ _jsx(MenuItem, _object_spread_props(_object_spread({
                            href: href,
                            scrollLayerRef: scrollLayerRef,
                            isActive: isActive,
                            isDisabled: disabled,
                            variant: "subMenu"
                        }, itemProps, linkProps), {
                            children: /*#__PURE__*/ _jsxs("div", {
                                style: {
                                    display: "flex",
                                    flexDirection: "row-reverse",
                                    alignItems: "flex-start",
                                    gap: "10px"
                                },
                                children: [
                                    Icon && /*#__PURE__*/ _jsx("img", {
                                        style: {
                                            width: "20px",
                                            height: "20px"
                                        },
                                        src: icon
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        children: labelItem ? labelItem : label
                                    }),
                                    isExternalLink && /*#__PURE__*/ _jsx(Box, {
                                        display: [
                                            "none",
                                            null,
                                            "flex"
                                        ],
                                        style: {
                                            alignItems: "center"
                                        },
                                        ml: "4px",
                                        children: /*#__PURE__*/ _jsx(OpenNewIcon, {
                                            color: "textSubtle"
                                        })
                                    })
                                ]
                            })
                        }))
                    }, label);
                })
            })
        ]
    }));
};
export default SubMenuItems;
